"use strict";
exports.__esModule = true;
exports.privateAttributes = exports.createLaunchDarklyUserObject = void 0;
var User = /** @class */ (function () {
    /**
     * @constructor
     * @param {string} id A unique identifier for this user. It must *not* be any form of PII.
     * @param {UserOptions} userOptions Optional attributes for a user.
     */
    function User(id, userOptions) {
        var _a;
        this.id = id;
        this.email = userOptions === null || userOptions === void 0 ? void 0 : userOptions.email;
        this.university = userOptions === null || userOptions === void 0 ? void 0 : userOptions.university;
        this.accountRole = userOptions === null || userOptions === void 0 ? void 0 : userOptions.accountRole;
        this.anonymous = (_a = userOptions === null || userOptions === void 0 ? void 0 : userOptions.anonymous) !== null && _a !== void 0 ? _a : false;
    }
    return User;
}());
exports["default"] = User;
/**
 * Convert our user object to the one that LaunchDarkly expects.
 * Explicitly takes values off the input object so that additional attributes cannot accidentally
 * be sent to LaunchDarkly. This is important so that we can be sure that we are only sending data that our customers know we are sending.
 * @param user The user data to send to LaunchDarkly.
 * @returns The user data converted to the format LaunchDarkly expects.
 */
function createLaunchDarklyUserObject(user) {
    var _a, _b, _c;
    var customObject = {};
    var userObject = {
        key: user.id,
        email: user.email,
        anonymous: user.anonymous,
        custom: customObject
    };
    userObject.custom.accountRole = user.accountRole;
    userObject.custom.universityId = (_a = user.university) === null || _a === void 0 ? void 0 : _a.id;
    userObject.custom.universitySlug = (_b = user.university) === null || _b === void 0 ? void 0 : _b.slug;
    userObject.custom.universityName = (_c = user.university) === null || _c === void 0 ? void 0 : _c.name;
    return userObject;
}
exports.createLaunchDarklyUserObject = createLaunchDarklyUserObject;
/**
 * @constant {string[]} The user attributes that must be configured as private in the LaunchDarkly client.
 */
exports.privateAttributes = ['email'];
